/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".formDocRef[_ngcontent-%COMP%]{position:relative;margin-left:7rem;margin-bottom:3rem;padding-top:0;bottom:20px;top:-20}.formDocFecha[_ngcontent-%COMP%], .formDocRazonRef[_ngcontent-%COMP%]{position:relative;margin-left:8rem;margin-bottom:1rem;padding-top:1px;bottom:0;width:100%}"];
export { styles as styles };
